// extracted by mini-css-extract-plugin
export default {"group-links__item":"cW6MKE"};